import { ChangeDetectionStrategy, Component, HostBinding, effect, input } from '@angular/core';

export type TagType =
	| 'delete'
	| 'primary'
	| 'basic'
	| 'proteins'
	| 'carbs'
	| 'fats'
	| 'kcal'
	| 'success'
	| 'warning'
	| 'sideMenuBasic';

@Component({
    selector: 'lib-tag',
    templateUrl: './tag.component.html',
    styleUrls: ['./tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TagComponent {
	public readonly tagType = input.required<TagType>();
	public readonly isClickable = input<boolean>(false);
	public readonly isFullSize = input<boolean>(false);

	@HostBinding('style') get style() {
		if (this.isFullSize()) {
			return 'display: block';
		} else {
			return 'display: inline-block';
		}
	}

	constructor() {}
}
